// src/registry.ts
var RETURN_VARIABLE_REGISTRY = {
  "shop.name": {
    id: "shop.name",
    name: "Nom du shop",
    description: "Nom de la boutique",
    type: "string",
    group: "shop",
    requires: ["shop"],
    exampleValue: "Ma Boutique",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.shop?.name ?? null,
    setter: (ctx, value) => {
      if (ctx.shop && typeof value === "string") {
        ctx.shop.name = value;
      }
    }
  },
  "shop.contactLink": {
    id: "shop.contactLink",
    name: "Lien de contact du shop",
    description: "Lien de contact de la boutique (URL ou adresse email mailto:)",
    type: "string",
    group: "shop",
    requires: ["shop"],
    exampleValue: "https://airtable.com/appXRhhvdy7hwn00G/pagc55vfl5aITm4ER/form",
    availableIn: ["template"],
    editable: false,
    injectableInText: true,
    resolver: (ctx) => ctx.shop?.preferences?.contactLink ?? null
  },
  "customer.firstName": {
    id: "customer.firstName",
    name: "Pr\xE9nom du client",
    description: "Pr\xE9nom du client ayant effectu\xE9 le retour",
    type: "string",
    group: "customer",
    requires: ["customer"],
    exampleValue: "Sophie",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.customer?.firstName ?? null,
    setter: (ctx, value) => {
      if (ctx.customer && typeof value === "string") {
        ctx.customer.firstName = value;
      }
    }
  },
  "customer.lastName": {
    id: "customer.lastName",
    name: "Nom du client",
    description: "Nom du client ayant effectu\xE9 le retour",
    type: "string",
    group: "customer",
    requires: ["customer"],
    exampleValue: "Martin",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.customer?.lastName ?? null,
    setter: (ctx, value) => {
      if (ctx.customer && typeof value === "string") {
        ctx.customer.lastName = value;
      }
    }
  },
  "customer.email": {
    id: "customer.email",
    name: "Email du client",
    description: "Adresse email du client",
    type: "string",
    group: "customer",
    requires: ["customer"],
    exampleValue: "sophie.martin@example.com",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.customer?.email ?? null,
    setter: (ctx, value) => {
      if (ctx.customer && typeof value === "string") {
        ctx.customer.email = value;
      }
    }
  },
  "return.id": {
    id: "return.id",
    name: "Identifiant du retour",
    description: "Identifiant unique de la demande de retour",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "RET-10042",
    availableIn: ["template"],
    editable: false,
    resolver: (ctx) => ctx.return?.id ?? null
  },
  "return.orderName": {
    id: "return.orderName",
    name: "Num\xE9ro de commande",
    description: "Num\xE9ro de la commande associ\xE9e au retour",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "#1042",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.return?.orderName ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.orderName = value;
      }
    }
  },
  "return.status": {
    id: "return.status",
    name: "Statut du retour",
    description: "Statut actuel de la demande de retour",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "approved",
    availableIn: ["template"],
    editable: false,
    resolver: (ctx) => ctx.return?.status ?? null
  },
  "return.reason": {
    id: "return.reason",
    name: "Motif du retour",
    description: "Raison indiqu\xE9e par le client pour le retour",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "Taille incorrecte",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.return?.reason ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.reason = value;
      }
    }
  },
  "return.createdAt": {
    id: "return.createdAt",
    name: "Date de cr\xE9ation",
    description: "Date de cr\xE9ation de la demande de retour (timestamp ms)",
    type: "number",
    group: "return",
    requires: ["return"],
    exampleValue: Date.now(),
    availableIn: ["template"],
    editable: false,
    injectableInText: false,
    resolver: (ctx) => ctx.return?.createdAt ?? null
  },
  "return.requestTimezone": {
    id: "return.requestTimezone",
    name: "Fuseau horaire de la demande",
    description: "Fuseau horaire IANA (ex. \xAB Europe/Paris \xBB) utilis\xE9 par le bloc Date de la demande pour formater la date de cr\xE9ation dans la langue du mail. Pr\xE9sent uniquement pour les clients europ\xE9ens.",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "Europe/Paris",
    // In "template" so the editor seeds the example value (drives the block
    // preview); hidden from the `@` picker via `pickable: false` in the editor.
    availableIn: ["template"],
    editable: false,
    injectableInText: false,
    resolver: (ctx) => ctx.return?.requestTimezone ?? null
  },
  "return.refundAmount": {
    id: "return.refundAmount",
    name: "Montant rembours\xE9",
    description: "Montant du remboursement",
    type: "number",
    group: "return",
    requires: ["return"],
    exampleValue: 49.99,
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.return?.refundAmount ?? null,
    setter: (ctx, value) => {
      const amount = typeof value === "number" ? value : Number(value);
      if (ctx.return && Number.isFinite(amount)) {
        ctx.return.refundAmount = amount;
      }
    }
  },
  "return.refundCurrency": {
    id: "return.refundCurrency",
    name: "Devise du remboursement",
    description: "Devise du montant rembours\xE9 (EUR, USD, etc.)",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "EUR",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.return?.refundCurrency ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.refundCurrency = value;
      }
    }
  },
  "return.labelUrl": {
    id: "return.labelUrl",
    name: "URL \xE9tiquette retour",
    description: "Lien de t\xE9l\xE9chargement de l'\xE9tiquette de retour",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "https://labels.example.com/return/abc123.pdf",
    availableIn: ["template"],
    editable: false,
    resolver: (ctx) => ctx.return?.labelUrl ?? null
  },
  "return.dropPointFinderUrl": {
    id: "return.dropPointFinderUrl",
    name: "URL point de d\xE9p\xF4t",
    description: "Lien vers le localisateur de points de d\xE9p\xF4t pour d\xE9poser le colis retour (\xE0 utiliser dans un bouton CTA)",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "https://localiser.laposte.fr/?jesuis=particulier&qp=12%20Rue%20de%20Bretagne%2C%2075003%2C%20Paris%2C%20France",
    availableIn: ["template"],
    editable: false,
    injectableInText: true,
    resolver: (ctx) => ctx.return?.dropPointFinderUrl ?? null
  },
  "return.trackingCode": {
    id: "return.trackingCode",
    name: "Num\xE9ro de suivi retour",
    description: "Num\xE9ro de suivi du colis retourn\xE9",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "1Z999AA10123456784",
    availableIn: ["template"],
    editable: true,
    resolver: (ctx) => ctx.return?.trackingCode ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.trackingCode = value;
      }
    }
  },
  "return.trackingUrl": {
    id: "return.trackingUrl",
    name: "URL de suivi du retour",
    description: "Lien vers la page de suivi et gestion du retour (\xE0 utiliser dans un bouton CTA)",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "https://my-shop.com/a/return?shop=shop-id&orderId=order-id",
    availableIn: ["template"],
    editable: false,
    injectableInText: true,
    resolver: (ctx) => ctx.return?.trackingUrl ?? null
  },
  "return.carrierCode": {
    id: "return.carrierCode",
    name: "Code transporteur",
    description: "Code interne du transporteur du retour (ex. colissimo, ups-express). Utilis\xE9 par le bloc Instructions de livraison.",
    type: "string",
    group: "return",
    requires: ["return"],
    exampleValue: "colissimo",
    availableIn: ["template"],
    editable: true,
    injectableInText: true,
    resolver: (ctx) => ctx.return?.carrierCode ?? null,
    setter: (ctx, value) => {
      if (ctx.return && typeof value === "string") {
        ctx.return.carrierCode = value;
      }
    }
  },
  "return.hasLogisticLabel": {
    id: "return.hasLogisticLabel",
    name: "Bon de retour logistique",
    description: "Indique si le retour utilise un bon de retour logistique. Utilis\xE9 par le bloc Instructions de livraison.",
    type: "boolean",
    group: "return",
    requires: ["return"],
    exampleValue: false,
    availableIn: [],
    editable: false,
    injectableInText: false,
    resolver: (ctx) => ctx.return?.hasLogisticLabel ?? null
  },
  "return.store": {
    id: "return.store",
    name: "Boutique de retour",
    description: "Informations sur la boutique o\xF9 d\xE9poser le retour (disponible uniquement pour les retours en boutique)",
    type: "object",
    group: "return",
    requires: ["return"],
    exampleValue: {
      name: "Boutique Paris Marais",
      address1: "12 Rue de Bretagne",
      address2: null,
      city: "Paris",
      zip: "75003",
      country: "France",
      mapUrl: "https://www.google.com/maps/place/12+Rue+de+Bretagne+75003+Paris"
    },
    availableIn: ["template"],
    editable: false,
    injectableInText: false,
    resolver: (ctx) => ctx.return?.store ?? null
  },
  "return.items": {
    id: "return.items",
    name: "Articles retourn\xE9s",
    description: "Liste des articles inclus dans le retour",
    type: "array",
    group: "return",
    requires: ["return"],
    exampleValue: [
      {
        name: "Robe fleurie taille M",
        quantity: 1,
        price: "49.99",
        paidPrice: "49.99",
        sku: "ROBE-M-001",
        imageUrl: "https://placehold.co/100x100",
        reason: "Taille incorrecte",
        resolution: "refund"
      },
      {
        name: "T-shirt coton",
        quantity: 1,
        price: "19.99",
        sku: "TSHIRT-L-002",
        imageUrl: "https://placehold.co/100x100",
        reason: "\xC9change de taille",
        resolution: "exchange",
        variant: { title: "L" },
        newVariant: { option1: "XL" }
      },
      {
        name: "Pull en laine",
        quantity: 2,
        price: "79.00",
        sku: "PULL-S-003",
        imageUrl: "https://placehold.co/100x100",
        reason: "Ne convient pas",
        resolution: "exchange-credit"
      },
      {
        name: "Casquette",
        quantity: 1,
        price: "24.50",
        sku: "CAP-001",
        imageUrl: "https://placehold.co/100x100",
        reason: "Geste commercial",
        resolution: "discount"
      }
    ],
    availableIn: ["template"],
    editable: false,
    injectableInText: false,
    resolver: (ctx) => ctx.return?.items ?? null
  }
};
var RETURN_VARIABLE_MAP = new Map(
  Object.entries(RETURN_VARIABLE_REGISTRY).map(([id, v]) => [id, v])
);
function getReturnVariableDefinition(id) {
  return RETURN_VARIABLE_MAP.get(id);
}

// src/subsets.ts
var RETURN_TEMPLATE_VARIABLES = Object.values(RETURN_VARIABLE_REGISTRY).filter(
  (v) => v.availableIn.includes("template")
);
function getReturnVariablesByGroup(variables) {
  return variables.reduce(
    (acc, variable) => {
      if (!acc[variable.group]) {
        acc[variable.group] = [];
      }
      acc[variable.group].push(variable);
      return acc;
    },
    {}
  );
}
function getActiveReturnVariables(variables) {
  return variables.filter((v) => !v.deprecated);
}

// src/groups.ts
var RETURN_VARIABLE_GROUPS = {
  shop: {
    icon: "store",
    labelKey: "returnVariableGroups.shop"
  },
  customer: {
    icon: "user",
    labelKey: "returnVariableGroups.customer"
  },
  return: {
    icon: "package",
    labelKey: "returnVariableGroups.return"
  }
};

// src/provider.tsx
function resolveReturnVariables(context) {
  const values = {};
  Object.values(RETURN_VARIABLE_REGISTRY).forEach((variable) => {
    values[variable.id] = variable.resolver(context);
  });
  return values;
}
function getReturnVariableExampleContext(shop) {
  const example = (id) => RETURN_VARIABLE_REGISTRY[id].exampleValue;
  return {
    shop: shop ?? null,
    customer: {
      firstName: example("customer.firstName"),
      lastName: example("customer.lastName"),
      email: example("customer.email")
    },
    return: {
      id: example("return.id"),
      orderName: example("return.orderName"),
      status: example("return.status"),
      reason: example("return.reason"),
      createdAt: example("return.createdAt"),
      requestTimezone: example("return.requestTimezone"),
      refundAmount: example("return.refundAmount"),
      refundCurrency: example("return.refundCurrency"),
      labelUrl: example("return.labelUrl"),
      trackingCode: example("return.trackingCode"),
      trackingUrl: example("return.trackingUrl"),
      dropPointFinderUrl: example("return.dropPointFinderUrl"),
      carrierCode: example("return.carrierCode"),
      hasLogisticLabel: example("return.hasLogisticLabel"),
      store: example(
        "return.store"
      ),
      items: example("return.items")
    }
  };
}
function applyReturnVariables(context, variables) {
  if (!variables) return context;
  for (const [variableId, value] of Object.entries(variables)) {
    if (value === void 0) continue;
    const definition = getReturnVariableDefinition(variableId);
    if (!definition?.setter) continue;
    try {
      definition.setter(context, value);
    } catch {
    }
  }
  return context;
}
function createReturnFormatter(values) {
  return (text) => {
    if (!text?.trim().length) return "";
    return text.replace(/\{\{\s*([^}]+)\s*\}\}/g, (match, variableId) => {
      const trimmedId = variableId.trim();
      const value = values[trimmedId];
      if (value === void 0 || value === null) {
        return match;
      }
      const definition = getReturnVariableDefinition(trimmedId);
      if (definition?.injectableInText === false) {
        return match;
      }
      if (typeof value === "object" && value !== null && !(value instanceof Date)) {
        return match;
      }
      return String(value);
    });
  };
}

export { RETURN_TEMPLATE_VARIABLES, RETURN_VARIABLE_GROUPS, RETURN_VARIABLE_MAP, RETURN_VARIABLE_REGISTRY, applyReturnVariables, createReturnFormatter, getActiveReturnVariables, getReturnVariableDefinition, getReturnVariableExampleContext, getReturnVariablesByGroup, resolveReturnVariables };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map